export default __webpack_public_path__ + "static/media/work_with_us.f40e9cc5.jpg";